<template>
    <TransitionRoot :show="store.showLoginDialog" as="template">
        <Dialog as="div" class="relative z-40" @close="store.showLoginDialog = false">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                             leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"/>
            </TransitionChild>

            <div class="fixed inset-0 z-10 overflow-y-auto">
                <div class="flex items-center justify-center min-h-full p-4 text-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300"
                                     enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                     enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                                     leave-from="opacity-100 translate-y-0 sm:scale-100"
                                     leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel
                                class="relative w-full max-w-lg overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8">
                            <div class="absolute top-0 right-0 block pt-4 pr-4">
                                <button class="text-gray-400 bg-white rounded-md hover:text-gray-600 focus:outline-hidden"
                                        type="button"
                                        @click="store.showLoginDialog = false">
                                    <span class="sr-only">Close</span>
                                    <svg class="w-6 h-6" fill="none" stroke="currentColor"
                                         stroke-width="1.5" viewBox="0 0 24 24"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>

                                </button>
                            </div>
                            <div>
                                <div class="mt-3 text-center sm:mt-5 sm:p-6">
                                    <DialogTitle as="h3"
                                                 class="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                                        Hello Stranger!
                                    </DialogTitle>


                                    <div class="mt-2">
                                        <p class="text-lg font-medium text-clay-800">
                                            Please <a class="text-gray-700 underline hover:text-gray-900" :href="`/login?redirect=${redirectUrl()}`">log in</a>
                                            or <a class="text-gray-700 underline hover:text-gray-900" :href="`/signup?redirect=${redirectUrl()}`">sign
                                            up</a> to continue.
                                        </p>
                                    </div>
                                </div>
                                <img class="mx-auto max-h-48"
                                     src="https://stagea.blob.core.windows.net/assets/home/images/SongsLandingImgOpera.png">
                            </div>
                            <div class="gap-3 px-4 py-4 space-y-3 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 bg-clay-50 sm:px-6 sm:space-y-0 ">
                                <a class="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-gray-700 bg-white border border-clay-500 rounded-md shadow-sm hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-electric-500 focus:ring-offset-2 sm:col-start-1 sm:text-sm"
                                   :href="`/login?redirect=${redirectUrl()}`">Login</a>
                                <a class="inline-flex justify-center w-full px-4 py-2 text-base font-semibold border border-transparent rounded-md shadow-sm bg-electric-600 text-white hover:bg-electric-700 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-electric-700 sm:col-start-2 sm:mt-0 sm:text-sm"
                                   :href="`/signup?redirect=${redirectUrl()}`"
                                >Sign up</a>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script lang="ts" setup>
// @ts-ignore
import {defineProps} from "vue";
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {store} from "@/store";

const redirectUrl = () => {
    return window.location.href.substring(window.location.origin.length);
}
</script>